import { render, staticRenderFns } from "./LinkExternal.vue?vue&type=template&id=5969774c&"
import script from "./LinkExternal.vue?vue&type=script&lang=ts&"
export * from "./LinkExternal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports